import { createTheme } from '@mui/material/styles'
import miniBookingLogo from '../../../assets/img/Jyrney/yourTMClogo.png'
import loginBackgroundImage from '../../../assets/img/login.jpeg'
import {
  default as loginLogo,
  default as logo,
} from '../../../assets/img/Veezu-BBC/Veezu-BBC-WhiteCoral.svg'
// import loginBackgroundImage from '../../../assets/img/login.jpeg'
import sidebarImage from '../../../assets/img/sidebar-road1.jpg'
import { grayColor } from '../../../materialUI/jss/material-dashboard-pro-react'
import hexToRgb from '../../utils/hexToRgb'

const veezuBlack = '#000000'
// const veezuWhite = '#FFFFFF'
const VeezuCoral = '#EC324C'
const VeezuHover = '#f26b87'

let theme = createTheme({
  colorBg: '#ffffff',
  brand: {
    name: '',
    logo: logo,
    sidebarImage: sidebarImage,
    miniBookingLogo: miniBookingLogo,
    browserTabName: 'Veezu BBC',
    favicon: 'https://www.veezu.co.uk/favicon.ico',
    sidebarLogoNoPadding: true,
  },
  map: {
    routeColor: VeezuCoral,
    routeColorSatellite: VeezuCoral,
  },
  palette: {
    brand: {
      dark: veezuBlack,
      main: veezuBlack,
      light: veezuBlack,
    },
    primary: {
      main: VeezuCoral,
      light: '#757de8',
      dark: veezuBlack,
      contrastText: '#ffffff',
    },
    secondary: {
      main: VeezuCoral,
      light: VeezuHover,
      dark: '#c08d00',
      contrastText: '#ffffff',
    },
    info: {
      main: '#55acee',
      light: '#8ddeff',
      dark: '#007dbb',
      contrastText: '#ffffff',
    },
    white: {
      main: '#FFFFFF',
      light: '#FFFFFF',
      dark: '#cccccc',
      contrastText: grayColor[0],
    },
    rose: {
      50: '#EC407A', //1
      100: '#EB3573', //3
      200: '#E91E63', //0
      300: '#D81B60', //2
      400: '#C2185B', //4
    },
    common: {
      black: '#000',
      white: '#FFF',
    },
  },
  typography: {
    fontFamily:
      'Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontFamilyDisplay:
      'Poppins, Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: { fontFamily: 'Poppins', fontWeight: 800 },
    h2: { fontFamily: 'Poppins', fontWeight: 700 },
    h3: { fontFamily: 'Poppins', fontWeight: 700 },
    h4: { fontFamily: 'Montserrat', fontWeight: 700 },
    h5: { fontFamily: 'Montserrat', fontWeight: 700 },
    h6: { fontFamily: 'Montserrat', fontWeight: 700 },
    body1: { fontFamily: 'Montserrat' },
    body2: { fontFamily: 'Montserrat' },
    button: {
      fontFamily: 'Poppins',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
})

theme = createTheme(theme, {
  pages: {
    loginPage: {
      backgroundImage: 'url(' + loginBackgroundImage + ')',
      //Header Box only allows for main colours.
      titleHeaderInnerColor: theme.palette.secondary.main,
      titleHeaderOuterColor: theme.palette.secondary.main,
      buttonColor: theme.palette.secondary.main,
      loginLogo: loginLogo,
    },
  },
})

theme = createTheme(theme, {
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          minHeight: 'auto',
          minWidth: 'auto',
          backgroundColor: grayColor[0],
          color: theme.palette.common.white,
          boxShadow:
            '0 2px 2px 0 rgba(' +
            hexToRgb(grayColor[0]) +
            ', 0.14), 0 3px 1px -2px rgba(' +
            hexToRgb(grayColor[0]) +
            ', 0.2), 0 1px 5px 0 rgba(' +
            hexToRgb(grayColor[0]) +
            ', 0.12)',
          border: 'none',
          borderRadius: '3px',
          position: 'relative',
          padding: '9.6px 24px',
          margin: '.3125rem 1px',
          fontFamily: 'Poppins',
          fontSize: '12px',
          fontWeight: '400',
          textTransform: 'uppercase',
          willChange: 'box-shadow, transform',
          transition:
            'box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          lineHeight: '1.42857143',
          textAlign: 'center',
          whiteSpace: 'nowrap',
          verticalAlign: 'middle',
          touchAction: 'manipulation',
          cursor: 'pointer',
          '&:hover,&:focus': {
            color: theme.palette.common.white,
            backgroundColor: grayColor[0],
            boxShadow:
              '0 14px 26px -12px rgba(' +
              hexToRgb(grayColor[0]) +
              ', 0.42), 0 4px 23px 0px rgba(' +
              hexToRgb(theme.palette.common.black) +
              ', 0.12), 0 8px 10px -5px rgba(' +
              hexToRgb(grayColor[0]) +
              ', 0.2)',
          },
          '& .fab,& .fas,& .far,& .fal,& .material-icons': {
            position: 'relative',
            display: 'inline-block',
            top: '0',
            marginTop: '-1em',
            marginBottom: '-1em',
            fontSize: '1.1rem',
            marginRight: '4px',
            verticalAlign: 'middle',
          },
          '& svg': {
            position: 'relative',
            display: 'inline-block',
            top: '0',
            width: '18px',
            height: '18px',
            marginRight: '4px',
            verticalAlign: 'middle',
          },
          '&$justicon': {
            '& .fab,& .fas,& .far,& .fal,& .material-icons': {
              marginTop: '0px',
              position: 'absolute',
              width: '100%',
              transform: 'none',
              left: '0px',
              top: '0px',
              height: '100%',
              lineHeight: '41px',
              fontSize: '20px',
            },
          },
          ...(ownerState?.simple && {
            '&,&:focus,&:hover': {
              color: theme.palette.common.white,
              background: 'transparent',
              boxShadow: 'none',
            },
          }),
          ...(ownerState?.simple &&
            ownerState?.color && {
              color:
                theme.palette[ownerState?.color]?.main ||
                theme.palette.common.white,
            }),
          ...(ownerState?.justicon && {
            paddingLeft: '12px',
            paddingRight: '12px',
            fontSize: '20px',
            height: '41px',
            minWidth: '41px',
            width: '41px',
            '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
              marginRight: '0px',
            },
            '&$lg': {
              height: '57px',
              minWidth: '57px',
              width: '57px',
              lineHeight: '56px',
              '& .fab,& .fas,& .far,& .fal,& .material-icons': {
                fontSize: '32px',
                lineHeight: '56px',
              },
              '& svg': {
                width: '32px',
                height: '32px',
              },
            },
            '&$sm': {
              height: '30px',
              minWidth: '30px',
              width: '30px',
              '& .fab,& .fas,& .far,& .fal,& .material-icons': {
                fontSize: '17px',
                lineHeight: '29px',
              },
              '& svg': {
                width: '17px',
                height: '17px',
              },
            },
          }),
          ...(ownerState?.size === 'sm' && {
            '&$justicon': {
              '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
                marginTop: '1px',
              },
            },
            padding: '0.40625rem 1.25rem',
            fontSize: '0.6875rem',
            lineHeight: '1.5',
          }),
          ...(ownerState?.size === 'lg' && {
            '&$justicon': {
              '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
                marginTop: '-4px',
              },
            },
            padding: '1.125rem 2.25rem',
            fontSize: '0.875rem',
            lineHeight: '1.333333',
            borderRadius: '0.2rem',
          }),
          ...(ownerState?.round && {
            borderRadius: '30px',
          }),
          ...(ownerState?.color && {
            boxShadow:
              '0 2px 2px 0 rgba(' +
              hexToRgb(grayColor[0]) +
              ', 0.14), 0 3px 1px -2px rgba(' +
              hexToRgb(grayColor[0]) +
              ', 0.2), 0 1px 5px 0 rgba(' +
              hexToRgb(grayColor[0]) +
              ', 0.12)',
            '&:hover,&:focus': {
              backgroundColor:
                theme.palette[ownerState?.color]?.main ||
                theme.palette.common.white,
              boxShadow:
                '0 14px 26px -12px rgba(' +
                hexToRgb(
                  theme.palette[ownerState?.color]?.main || grayColor[0],
                ) +
                ', 0.42), 0 4px 23px 0px rgba(' +
                hexToRgb(theme.palette.common.black) +
                ', 0.12), 0 8px 10px -5px rgba(' +
                hexToRgb(
                  theme.palette[ownerState?.color]?.main || grayColor[0],
                ) +
                ', 0.2)',
            },
          }),
          ...(ownerState?.color === 'primary' && {
            backgroundColor: theme.palette.primary.main,
          }),
          ...(ownerState?.color === 'secondary' && {
            backgroundColor: theme.palette.secondary.main,
          }),
          ...(ownerState?.color === 'error' && {
            backgroundColor: theme.palette.error.light,
          }),
          ...(ownerState?.color === 'info' && {
            fontFamily: 'Poppins',
            color: '#2f2f2f',
            backgroundColor: '#ffffff',
            border: `2px solid ${theme.palette.info.main}`,
            letterSpacing: '2px',
          }),
          ...(ownerState?.color === 'white' && {
            boxShadow:
              '0 2px 2px 0 rgba(' +
              hexToRgb(grayColor[0]) +
              ', 0.14), 0 3px 1px -2px rgba(' +
              hexToRgb(grayColor[0]) +
              ', 0.2), 0 1px 5px 0 rgba(' +
              hexToRgb(grayColor[0]) +
              ', 0.12)',
            '&:hover,&:focus': {
              backgroundColor: theme.palette.common.white,
              boxShadow:
                '0 14px 26px -12px rgba(' +
                hexToRgb(grayColor[0]) +
                ', 0.42), 0 4px 23px 0px rgba(' +
                hexToRgb(theme.palette.common.black) +
                ', 0.12), 0 8px 10px -5px rgba(' +
                hexToRgb(grayColor[0]) +
                ', 0.2)',
            },
            '&,&:focus,&:hover': {
              backgroundColor: theme.palette.white.main,
              color: grayColor[0],
            },
          }),
          ...(ownerState?.transparent && {
            '&,&:focus,&:hover': {
              color: 'inherit',
              background: 'transparent',
              boxShadow: 'none',
            },
          }),
          ...(ownerState?.disabled && {
            opacity: '0.65',
            pointerEvents: 'none',
          }),
          ...(ownerState?.outlined && {
            border: '1px solid',
            borderColor: theme.palette.primary.main,
            background: 'transparent',
            color: theme.palette.primary.main,
            '&:focus,&:hover': {
              color: theme.palette.common.white,
              background: theme.palette.primary.main,
              boxShadow: 'none',
            },
          }),
          ...(ownerState?.text && {
            color: theme.palette.primary.main,
            fontWeight: 'bold',
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            padding: '5px',
            margin: 0,
            '&:focus,&:hover': {
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none',
            },
            opacity: ownerState.disabled ? 0.5 : 1,
          }),
          ...(ownerState?.variant === 'text' && {
            boxShadow: 'none',
            '&:hover,&:focus': { boxShadow: 'none' },
          }),
        }),
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: ({ theme }) => ({
          zIndex: 0,
          backgroundColor: 'white',
          borderRadius: 4,
          position: 'relative',
          border: '1px solid #ced4da',
          fontSize: 16,
          '&:focus': {
            boxShadow: `rgba(${hexToRgb(
              theme.palette.primary.main,
            )}, 0.25) 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
          },
        }),
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          margin: '0',
          padding: '0',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          padding: '0',
          margin: '0',
        },
      },
    },
    MuiIcon: {
      styleOverrides: {
        root: {
          margin: '0',
          padding: '0',
        },
      },
    },
    Sidebar: {
      styleOverrides: {
        overlay: {
          background: veezuBlack,
        },
      },
    },
    CardHeader: {
      styleOverrides: {
        root: (ownerState, theme) => {
          const color = ownerState?.color || 'white'
          const simple = ownerState?.simple

          const style = {
            background: simple
              ? theme.pages.loginPage.titleHeaderOuterColor
              : `linear-gradient(60deg, ${theme.palette[color]?.dark}, ${theme.palette[color]?.light})`,
          }

          if (color !== 'white') {
            style.boxShadow =
              '0 4px 20px 0 rgba(' +
              hexToRgb(theme.palette.common.black) +
              ',.14), 0 7px 10px -5px rgba(' +
              hexToRgb(theme.pages.loginPage.titleHeaderOuterColor) +
              ',.4)'
          }

          return style
        },
      },
    },
    CardIcon: {
      styleOverrides: {
        root: (ownerState, theme) => {
          const color = ownerState?.color || 'white'
          const simple = ownerState?.simple

          const style = {
            background: simple
              ? theme.palette[color].main
              : `linear-gradient(60deg, ${theme.palette[color]?.dark}, ${theme.palette[color]?.light})`,
          }

          if (color !== 'white') {
            style.boxShadow =
              '0 4px 20px 0 rgba(' +
              hexToRgb(theme.palette.common.black) +
              ',.14), 0 7px 10px -5px rgba(' +
              hexToRgb(theme.palette[color]?.dark) +
              ',.4)'
          }

          return style
        },
      },
    },
    cancelButton: {
      backgroundColor: '#000000',
    },
    bookingSummary: {
      backgroundImage: theme.palette.white.main,
      headerColour: '#000000',
      headerTextColour: theme.palette.white.main,
      sectionTitle: '#000000',
      sectionAnswerPending: '#8e8e8e',
      sectionAnswerComplete: theme.palette.secondary.light,
      iconLineComplete: theme.palette.secondary.main,
      iconLinePending: '#8e8e8e',
      iconFillComplete: theme.palette.white.main,
      iconFillPending: '#8e8e8e',
    },
    journeyStatus: {
      headerColour: theme.palette.brand.dark,
      headerTextColour: theme.palette.white.main,
    },
    BookingTable: {
      headerColour: theme.palette.brand.light,
    },
  },
  tableComponents: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          textAlign: 'left',
          textTransform: 'none',
          padding: '0',
          justifyContent: 'flex-start',
          '&:hover': {
            background: 'unset',
          },
        },
      },
    },
  },
})

export default theme
